"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apiUri = "".concat(process.env.DOMAIN_NAME, "/api/graphql");
var environment = {
    apiUri: apiUri.startsWith('http') ? apiUri : "https://".concat(apiUri),
};
exports.default = environment;
